import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Figure from 'react-bootstrap/Figure';
import { Link } from "react-router-dom";
import './aboutUs.scss'
import ab1 from './ab1.png'
import ab2 from './ab2.png'
import ab3 from './ab3.png'
import how1 from './how1.png'
import how2 from './how2.png'
import how3 from './how3.png'
function AboutUs(props) {
    return (
        <div>
            <Container>
            <Row>
                <Col className='about-title'>Що ми робимо?</Col>
            </Row>
            <Row>
                <Col>
                    <Figure style={{height:'280px'}}>
                        <Figure.Image
                            width={161}
                            height={170}
                            alt="171x180"
                            src={ab1}
                        />
                        <Figure.Caption className='about-title-container'>Координуємо</Figure.Caption>
                        <Figure.Caption className='about-text'>Забезпечуємо інформацією про перевезення</Figure.Caption>
                        
                    </Figure>
                    <Link to="/information" relative="path">
                    <Button variant="outline-warning" style={{marginTop:'2%'}}>Докладніше</Button>
                    </Link>
                </Col>
                <Col>
                <Figure style={{height:'280px'}}>
                        <Figure.Image
                            width={161}
                            height={170}
                            alt="171x180"
                            src={ab2}
                        />
                        <Figure.Caption className='about-title-container'>Формуємо спільноти</Figure.Caption>
                        <Figure.Caption className='about-text'>Створюємо зручні відомості на карті про об'єкти допомоги</Figure.Caption>
                    </Figure>
                    <Link to="/search" relative="path">
                    <Button variant="outline-warning"  style={{marginTop:'2%'}}>Докладніше</Button>
                    </Link>
                </Col>
                <Col>
                <Figure style={{height:'280px'}}>
                        <Figure.Image
                            width={161}
                            height={170}
                            alt="171x180"
                            src={ab3}
                        />
                        <Figure.Caption className='about-title-container'>Розповідаємо</Figure.Caption>
                        <Figure.Caption className='about-text'>Допоможемо з детальною інформацією на форумі і в чат боті</Figure.Caption>
                    </Figure>
                    <Link to="/forum" relative="path">
                    <Button variant="outline-warning"  style={{marginTop:'2%'}}>Докладніше</Button>
                    </Link>
                </Col>
            </Row>

            <Row>
                <Col className='about-title'>Як долучитися?</Col>
            </Row>
            <Row>
                <Col>
                    <Figure>
                        <Figure.Image
                            width={300}
                            height={400}
                            alt="171x180"
                            src={how1}
                        />
                        {/* <Figure.Caption className='about-title-container'>Розповідаємо</Figure.Caption> */}
                        <Figure.Caption className='about-text-how'>Заповнюй форму реєстрації та доєднуйся до команди</Figure.Caption>
                    </Figure>
                    <Link to="/register" relative="path">
                    <Button variant="outline-warning"  style={{marginTop:'2%'}}>Зареєструватися</Button>
                    </Link>
                </Col>
                <Col>
                <Figure>
                        <Figure.Image
                            width={300}
                            height={400}
                            alt="171x180"
                            src={how2}
                        />
                        {/* <Figure.Caption className='about-title-container'>Розповідаємо</Figure.Caption> */}
                        <Figure.Caption className='about-text-how'>Допомагай людям, бери участь в обговореннях і відповідай на питання</Figure.Caption>
                    </Figure>
                    <Link to="/forum" relative="path">
                    <Button variant="outline-warning"  style={{marginTop:'2%'}}>До форуму</Button>
                    </Link>
                </Col>
                <Col>
                <Figure>
                        <Figure.Image
                            width={300}
                            height={400}
                            alt="171x180"
                            src={how3}
                        />
                        {/* <Figure.Caption className='about-title-container'>Розповідаємо</Figure.Caption> */}
                        <Figure.Caption className='about-text-how'>Створюй об'єкти допомоги та координуй людей</Figure.Caption>
                    </Figure>
                </Col>
            </Row>
            </Container>
        </div>
    );
}

export default AboutUs;